export const GET_JOB_LIST_LOADING = "GET_JOB_LIST_LOADING";
export const GET_JOB_LIST_SUCCESS = "GET_JOB_LIST_SUCCESS";
export const GET_JOB_LIST_FAILURE = "GET_JOB_LIST_FAILURE";

export const GET_QUERY_PARAM = "GET_QUERY_PARAM";

export const LOG_EVENTS_LOADING = "LOG_EVENTS_LOADING";
export const LOG_EVENTS_SUCCESS = "LOG_EVENTS_SUCCESS";
export const LOG_EVENTS_FAILURE = "LOG_EVENTS_FAILURE";

export const NPS_QUESTIONS_LOADING = "NPS_QUESTIONS_LOADING";
export const NPS_QUESTIONS_SUCCESS = "NPS_QUESTIONS_SUCCESS";
export const NPS_QUESTIONS_FAILURE = "NPS_QUESTIONS_FAILURE";

export const NPS_SUBMIT_LOADING = "NPS_SUBMIT_LOADING";
export const NPS_SUBMIT_SUCCESS = "NPS_SUBMIT_SUCCESS";
export const NPS_SUBMIT_FAILURE = "NPS_SUBMIT_FAILURE";

export const GET_DEVICE_TYPE = "GET_DEVICE_TYPE";

export const REFERRAL_LOADING = "REFERRAL_LOADING";
export const REFERRAL_SUCCESS = "REFERRAL_SUCCESS";
export const REFERRAL_FAILURE = "REFERRAL_FAILURE";

export const MANAGE_SESSION_LOADING = "MANAGE_SESSION_LOADING";
export const MANAGE_SESSION_SUCCESS = "MANAGE_SESSION_SUCCESS";
export const MANAGE_SESSION_FAILURE = "MANAGE_SESSION_FAILURE";

export const IS_TOOLTIP_SHOWING = "IS_TOOLTIP_SHOWING";

export const IS_APP_LOADING = "IS_APP_LOADING";

export const JOB_REFRESH_LOADING = "JOB_REFRESH_LOADING";
export const JOB_REFRESH_SUCCESS = "JOB_REFRESH_SUCCESS";
export const JOB_REFRESH_FAILURE = "JOB_REFRESH_FAILURE";

export const GET_PREMIUM_INTENT_LOADING = "GET_PREMIUM_INTENT_LOADING";
export const GET_PREMIUM_INTENT_SUCCESS = "GET_PREMIUM_INTENT_SUCCESS";
export const GET_PREMIUM_INTENT_FAILURE = "GET_PREMIUM_INTENT_FAILURE";

export const CAPTCHA_STATE = "CAPTCHA_STATE";
export const SET_TOOLTIP_CONDITIONS_MET = "SET_TOOLTIP_CONDITIONS_MET";
